module.exports = __webpack_public_path__ + "static/media/b.b82bf096.jpg";